import { Typography } from "@mui/material";
import { Outlet } from "react-router-dom";

const Schedules = () => {
  return (
    <>
      <Typography className="main_heading">Schedules</Typography>
      <Outlet />
    </>
  );
};

export default Schedules;
